webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(8)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(5),
  /* template */
  __webpack_require__(14),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Quiz__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Quiz___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Quiz__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    Quiz: __WEBPACK_IMPORTED_MODULE_0__components_Quiz___default.a
  },
  data: function data() {
    return {
      startedQuiz: false,
      questions: [{
        a: 'A',
        b: 'B<sub>2</sub>',
        ab: 'AB<sub>2</sub>',
        k: '6.8 &times; 10<sup>3</sup>',
        conc_a: '[0.0010]',
        conc_b: '[0.0020]',
        conc_ab: '[0.017]',
        answer: 8.5,
        exponent: 3,
        shift: 'left'
      }, {
        a: 'A<sub>2</sub>',
        b: 'B<sub>2</sub>',
        ab: '2AB',
        k: '4.9 &times; 10<sup>2</sup>',
        conc_a: '[1.1]',
        conc_b: '[0.055]',
        conc_ab: '[0.95]',
        answer: 1.5,
        exponent: 1,
        shift: 'right'
      }, {
        a: false,
        b: '2AB<sub>2</sub>',
        ab: 'A<sub>2</sub>B<sub>4</sub>',
        k: '3.2 &times; 10<sup>0</sup>',
        conc_a: false,
        conc_b: '[0.54]',
        conc_ab: '[0.93]',
        answer: 3.2,
        exponent: 0,
        shift: 'equal'
      }, {
        a: '2A<sub>2</sub>B<sub>2</sub>',
        b: '2AB<sub>2</sub>',
        ab: 'B<sub>2</sub>',
        abflip: true,
        k: '9.1 &times; 10<sup>-1</sup>',
        conc_a: '[0.055]',
        conc_b: '[0.038]',
        conc_ab: '[0.46]',
        answer: 2.2,
        exponent: -1,
        shift: 'right'
      }, {
        a: '2A',
        b: '3B<sub>2</sub>',
        ab: '2AB<sub>3</sub>',
        k: '5.6 &times; 10<sup>-3</sup>',
        conc_a: '[0.75]',
        conc_b: '[0.38]',
        conc_ab: '[0.013]',
        answer: 5.5,
        exponent: -3,
        shift: 'equal'
      }, {
        a: 'A<sub>2</sub>',
        b: 'B<sub>2</sub>',
        ab: '2AB',
        k: '4.9 &times; 10<sup>2</sup>',
        conc_a: '[0.0031]',
        conc_b: '[0.026]',
        conc_ab: '[0.94]',
        answer: 1.1,
        exponent: 4,
        shift: 'left'
      }, {
        a: '2A<sub>2</sub>B<sub>2</sub>',
        b: '2AB<sub>2</sub>',
        ab: 'B<sub>2</sub>',
        abflip: true,
        k: '9.1 &times; 10<sup>-1</sup>',
        conc_a: '[0.096]',
        conc_b: '[0.11]',
        conc_ab: '[0.69]',
        answer: 9.1,
        exponent: -1,
        shift: 'equal'
      }, {
        a: '2A',
        b: '3B<sub>2</sub>',
        ab: '2AB<sub>3</sub>',
        k: '5.6 &times; 10<sup>-3</sup>',
        conc_a: '[0.88]',
        conc_b: '[0.75]',
        conc_ab: '[0.045]',
        answer: 6.2,
        exponent: -3,
        shift: 'left'
      }, {
        a: 'A',
        b: 'B<sub>2</sub>',
        ab: 'AB<sub>2</sub>',
        k: '6.8 &times; 10<sup>3</sup>',
        conc_a: '[0.0020]',
        conc_b: '[0.014]',
        conc_ab: '[0.19]',
        answer: 6.8,
        exponent: 3,
        shift: 'equal'
      }, {
        a: false,
        b: '2AB<sub>2</sub>',
        ab: 'A<sub>2</sub>B<sub>4</sub>',
        k: '3.2 &times; 10<sup>0</sup>',
        conc_a: false,
        conc_b: '[0.065]',
        conc_ab: '[0.68]',
        answer: 1.6,
        exponent: 2,
        shift: 'left'
      }, {
        a: '2A',
        b: '3B<sub>2</sub>',
        ab: '2AB<sub>3</sub>',
        k: '5.6 &times; 10<sup>-3</sup>',
        conc_a: '[0.63]',
        conc_b: '[0.77]',
        conc_ab: '[0.0087]',
        answer: 4.2,
        exponent: -4,
        shift: 'right'
      }, {
        a: 'A<sub>2</sub>',
        b: 'B<sub>2</sub>',
        ab: '2AB',
        k: '4.9 &times; 10<sup>2</sup>',
        conc_a: '[0.039]',
        conc_b: '[0.025]',
        conc_ab: '[0.69]',
        answer: 4.9,
        exponent: 2,
        shift: 'equal'
      }, {
        a: false,
        b: '2AB<sub>2</sub>',
        ab: 'A<sub>2</sub>B<sub>4</sub>',
        k: '3.2 &times; 10<sup>0</sup>',
        conc_a: false,
        conc_b: '[0.96]',
        conc_ab: '[0.011]',
        answer: 1.2,
        exponent: -2,
        shift: 'right'
      }, {
        a: '2A<sub>2</sub>B<sub>2</sub>',
        b: '2AB<sub>2</sub>',
        ab: 'B<sub>2</sub>',
        abflip: true,
        k: '9.1 &times; 10<sup>-1</sup>',
        conc_a: '[0.045]',
        conc_b: '[0.055]',
        conc_ab: '[0.66]',
        answer: 9.9,
        exponent: -1,
        shift: 'left'
      }, {
        a: 'A',
        b: 'B<sub>2</sub>',
        ab: 'AB<sub>2</sub>',
        k: '6.8 &times; 10<sup>3</sup>',
        conc_a: '[0.0029]',
        conc_b: '[0.076]',
        conc_ab: '[0.0095]',
        answer: 4.3,
        exponent: 1,
        shift: 'right'
      }]
    };
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'quiz',
  data: function data() {
    return {
      debug: false,
      hinting: false,
      guessed: false,
      guessed2: false,
      alright: false,
      wrongs: 0,
      missed: '',
      answer: '',
      exponent: '',
      direction: '',
      currentQ: false,
      currentCount: 0,
      correct: 0,
      errorExponent: false,
      errorAnswer: false,
      q2error: false,
      completed: false,
      submitText: 'Submit'
    };
  },
  props: ['questions', 'startedQuiz'],
  computed: {
    classLeft: function classLeft() {
      var c = [];
      if (this.direction === 'left' && this.missed) {
        c.push('wrong');
      }
      if (this.direction !== 'left' && this.missed === 'left') {
        c.push('missed');
      }
      if (this.guessed2 === true) {
        c.push('guessed2');
      }
      return c;
    },
    classRight: function classRight() {
      var c = [];
      if (this.direction === 'right' && this.missed) {
        c.push('wrong');
      }
      if (this.direction !== 'right' && this.missed === 'right') {
        c.push('missed');
      }
      if (this.guessed2 === true) {
        c.push('guessed2');
      }
      return c;
    },
    classEqual: function classEqual() {
      var c = [];
      if (this.direction === 'equal' && this.missed) {
        c.push('wrong');
      }
      if (this.direction !== 'equal' && this.missed === 'equal') {
        c.push('missed');
      }
      if (this.guessed2 === true) {
        c.push('guessed2');
      }
      return c;
    },
    hintBottom: function hintBottom() {
      if (this.currentQ.a) {
        var exp1 = this.currentQ.a.match(/(\d)(A|B)/);
      }
      if (exp1) {
        exp1 = '<sup>' + exp1[1] + '</sup>';
      } else {
        exp1 = '';
      }
      var exp2 = this.currentQ.b.match(/(\d)(A|B)/);
      if (exp2) {
        exp2 = '<sup>' + exp2[1] + '</sup>';
      } else {
        exp2 = '';
      }

      var r = '';
      if (this.currentQ.abflip) {
        r = '[' + this.currentQ.a.replace(/(\d)(A|B)/, '$2') + ']' + exp1;
      } else {
        if (this.currentQ.a) {
          r = '[' + this.currentQ.a.replace(/(\d)(A|B)/, '$2') + ']' + exp1;
        }
        r += '[' + this.currentQ.b.replace(/(\d)(A|B)/, '$2') + ']' + exp2;
      }
      return r;
    },
    hintTop: function hintTop() {
      var exp1 = this.currentQ.ab.match(/(\d)(A|B)/);
      if (exp1) {
        exp1 = '<sup>' + exp1[1] + '</sup>';
      } else {
        exp1 = '';
      }
      var exp2 = this.currentQ.b.match(/(\d)(A|B)/);
      if (exp2) {
        exp2 = '<sup>' + exp2[1] + '</sup>';
      } else {
        exp2 = '';
      }

      var r = '';
      if (this.currentQ.abflip) {
        r = '[' + this.currentQ.b.replace(/(\d)(A|B)/, '$2') + ']' + exp2;
        r += '[' + this.currentQ.ab.replace(/(\d)(A|B)/, '$2') + ']' + exp1;
      } else {
        r = '[' + this.currentQ.ab.replace(/(\d)(A|B)/, '$2') + ']' + exp1;
      }
      return r;
    }
  },
  methods: {
    gowhee: function gowhee(to, duration) {
      to = Math.ceil(to / 10) * 10; // round to nearest 10
      var element = document.documentElement;
      var difference = to - element.scrollTop;
      var perTick = difference / duration * 10;
      var my = this;
      setTimeout(function () {
        // stop when you get there
        if (element.scrollTop === to || duration <= 0) return;
        element.scrollTop = element.scrollTop + perTick;
        my.gowhee(to, duration - 10);
      }, 10);
    },
    showHint: function showHint(e) {
      e.preventDefault();
      this.hinting = !this.hinting;
    },
    submitOne: function submitOne(e) {
      e.preventDefault();

      if (this.answer === '' || this.exponent === '') {
        if (this.answer === '') {
          this.errorAnswer = true;
        }
        if (this.exponent === '') {
          this.errorExponent = true;
        }
        return false;
      }

      if (parseFloat(this.answer) !== this.currentQ.answer || parseFloat(this.exponent) !== this.currentQ.exponent) {
        if (parseFloat(this.answer) !== this.currentQ.answer) {
          this.errorAnswer = true;
        }
        if (parseFloat(this.exponent) !== this.currentQ.exponent) {
          this.errorExponent = true;
        }
        this.hinting = true;
        this.wrongs++;
        if (this.wrongs > 1) {
          this.answer = this.currentQ.answer;
          this.exponent = this.currentQ.exponent;
          this.submitText = 'Continue';
        } else {
          this.submitText = 'Try Again';
        }
        return false;
      }

      this.guessed = true;

      var my = this;
      setTimeout(function () {
        my.gowhee(document.documentElement.offsetHeight, 250);
      }, 100);
    },
    checkError: function checkError(el) {
      if (this.errorAnswer && el === 'answer') {
        this.errorAnswer = false;
      }
      if (this.errorExponent && el === 'exponent') {
        this.errorExponent = false;
      }
      this.submitText = 'Submit';
    },
    submitTwo: function submitTwo(e) {
      e.preventDefault();

      var my = this;
      if (this.direction === '') {
        this.q2error = true;
        setTimeout(function () {
          my.q2error = false;
        }, 1000);
        return false;
      }

      this.guessed2 = true;

      if (this.direction !== this.currentQ.shift) {
        this.missed = this.currentQ.shift;
        setTimeout(function () {
          my.gowhee(document.documentElement.offsetHeight, 1000);
        }, 1500);
      } else {
        this.alright = true;
        this.correct++;
        setTimeout(function () {
          my.gowhee(document.documentElement.offsetHeight, 250);
        }, 1500);
      }
    },
    nextQuestion: function nextQuestion(e) {
      this.currentCount++;
      this.guessed = this.guessed2 = false;
      this.hinting = false;
      this.errorExponent = this.errorAnswer = false;
      this.alright = false;
      this.missed = '';
      this.wrongs = 0;
      this.submitText = 'Submit';
      this.answer = '';
      this.exponent = '';
      this.direction = '';

      if (this.currentCount === this.questions.length) {
        // done!
        this.completed = true;
      } else {
        // next question
        this.currentQ = this.questions[this.currentCount];
        var my = this;
        setTimeout(function () {
          my.gowhee(0, 250);
        }, 100);
      }
    },
    resetEverything: function resetEverything() {
      this.completed = false;
      this.$emit('restartQuiz');
      this.currentCount = this.correct = 0;
      this.currentQ = this.questions[this.currentCount];
    }
  },
  created: function created() {
    this.currentQ = this.questions[this.currentCount];
    // toggle debug mode with ctrl+shift+space
    var my = this;
    window.addEventListener('keydown', function (e) {
      if (e.keyCode === 32 && e.shiftKey && e.ctrlKey) {
        my.debug = !my.debug;
      }
    });
  }
});

/***/ }),
/* 7 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 8 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(7)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(13),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0459d559",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.completed),
      expression: "!completed"
    }]
  }, [_c('div', {
    staticClass: "question"
  }, [_c('div', {
    staticClass: "equation"
  }, [(this.currentQ.a) ? _c('span', {
    staticClass: "a",
    attrs: {
      "id": "a"
    },
    domProps: {
      "innerHTML": _vm._s(this.currentQ.a)
    }
  }) : _vm._e(), _vm._v(" "), (this.currentQ.abflip) ? _c('span', {
    staticClass: "e"
  }, [_vm._v("↔")]) : (this.currentQ.a) ? _c('span', {
    staticClass: "p"
  }, [_vm._v("+")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "b",
    attrs: {
      "id": "b"
    },
    domProps: {
      "innerHTML": _vm._s(this.currentQ.b)
    }
  }), _vm._v(" "), (this.currentQ.abflip) ? _c('span', {
    staticClass: "p"
  }, [_vm._v("+")]) : _c('span', {
    staticClass: "e"
  }, [_vm._v("↔")]), _vm._v(" "), _c('span', {
    staticClass: "ab",
    attrs: {
      "id": "ab"
    },
    domProps: {
      "innerHTML": _vm._s(this.currentQ.ab)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "concentrations"
  }, [(this.currentQ.conc_a) ? _c('span', {
    staticClass: "a",
    attrs: {
      "id": "conc_a"
    },
    domProps: {
      "innerHTML": _vm._s(this.currentQ.conc_a)
    }
  }) : _vm._e(), _vm._v(" "), (this.currentQ.abflip) ? _c('span', {
    staticClass: "e"
  }, [_vm._v("↔")]) : (this.currentQ.a) ? _c('span', {
    staticClass: "p"
  }, [_vm._v("+")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "b",
    attrs: {
      "id": "conc_b"
    },
    domProps: {
      "innerHTML": _vm._s(this.currentQ.conc_b)
    }
  }), _vm._v(" "), (this.currentQ.abflip) ? _c('span', {
    staticClass: "p"
  }, [_vm._v("+")]) : _c('span', {
    staticClass: "e"
  }, [_vm._v("↔")]), _vm._v(" "), _c('span', {
    staticClass: "ab",
    attrs: {
      "id": "conc_ab"
    },
    domProps: {
      "innerHTML": _vm._s(this.currentQ.conc_ab)
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "id": "k"
    }
  }, [_vm._v("K = "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(this.currentQ.k)
    }
  })])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeQuiz"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.guessed),
      expression: "!guessed"
    }]
  }, [_c('div', {
    staticClass: "guess",
    class: _vm.hinting ? 'hint' : ''
  }, [_c('div', {
    staticClass: "col-2-3"
  }, [_c('p', [_vm._v("Enter a digit between 1.0 and 9.9")]), _vm._v(" "), _c('div', [_c('span', [_vm._v("Q =")]), _vm._v(" "), _c('span', {
    class: _vm.hinting ? 'hint' : '',
    attrs: {
      "id": "hint"
    }
  }, [_c('span', {
    staticClass: "fraction",
    class: this.currentQ.abflip ? 'abflip' : ''
  }, [_c('span', {
    attrs: {
      "id": "hinttop"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.hintTop)
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "id": "hintbot"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.hintBottom)
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "equals"
  }, [_vm._v("=")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.answer),
      expression: "answer"
    }],
    staticClass: "num",
    class: _vm.errorAnswer ? 'error' : '',
    attrs: {
      "placeholder": "Type in your answer",
      "type": "number",
      "min": "1",
      "max": "9.9",
      "step": "0.1",
      "disabled": _vm.submitText == 'Continue' ? 'disabled' : false
    },
    domProps: {
      "value": (_vm.answer)
    },
    on: {
      "click": function($event) {
        _vm.checkError('answer')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.answer = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "times"
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-1-3"
  }, [_c('p', [_vm._v("Exponent")]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "number"
  }, [_vm._v("10 "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exponent),
      expression: "exponent"
    }],
    staticClass: "exp",
    class: _vm.errorExponent ? 'error' : '',
    attrs: {
      "placeholder": "Exponent",
      "type": "number",
      "min": "-9",
      "max": "9",
      "step": "1",
      "disabled": _vm.submitText == 'Continue' ? 'disabled' : false
    },
    domProps: {
      "value": (_vm.exponent)
    },
    on: {
      "click": function($event) {
        _vm.checkError('exponent')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.exponent = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitText == 'Continue'),
      expression: "submitText=='Continue'"
    }],
    staticClass: "submits"
  }, [_c('p', [_vm._v("Correct answer shown, you may continue.")])]), _vm._v(" "), _c('div', {
    staticClass: "submits"
  }, [_c('button', {
    staticClass: "btn submit",
    attrs: {
      "disabled": _vm.submitText == 'Try Again' ? 'disabled' : false
    },
    on: {
      "click": _vm.submitOne
    }
  }, [_vm._v(_vm._s(_vm.submitText))]), _vm._v(" "), _c('a', {
    staticClass: "btn alt",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.showHint
    }
  }, [_vm._v("Show Hint")])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeQuiz"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.guessed),
      expression: "guessed"
    }]
  }, [_c('div', {
    staticClass: "guess guessed"
  }, [_c('div', [_c('span', [_vm._v("Q = ")]), _vm._v(" "), _c('span', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.answer))]), _vm._v(" "), _c('span', {
    staticClass: "number"
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    staticClass: "number"
  }, [_vm._v("10"), _c('sup', [_vm._v(_vm._s(_vm.exponent))])])])]), _vm._v(" "), _c('div', {
    staticClass: "guess-second",
    class: _vm.q2error ? 'q2error' : ''
  }, [_c('p', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitText == 'Submit'),
      expression: "submitText=='Submit'"
    }],
    staticClass: "preq2"
  }, [_vm._v("Correct!")]), _vm._v(" Question 2: In which direction will equilibrium shift?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.direction),
      expression: "direction"
    }],
    attrs: {
      "type": "radio",
      "value": "left",
      "id": "left",
      "disabled": _vm.guessed2
    },
    domProps: {
      "checked": _vm._q(_vm.direction, "left")
    },
    on: {
      "change": function($event) {
        _vm.direction = "left"
      }
    }
  }), _vm._v(" "), _c('label', {
    class: _vm.classLeft,
    attrs: {
      "for": "left"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("A")]), _vm._v(" "), (_vm.missed == 'left') ? _c('span', [_vm._v("\n              Since Q is greater than K there are initially too many products and too few reactants present. The reaction will shift left to produce more reactants until equilibrium is reached.\n            ")]) : _c('span', [_vm._v("Since Q is greater than K, equilibrium will shift left towards the reactants.")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.direction),
      expression: "direction"
    }],
    attrs: {
      "type": "radio",
      "value": "right",
      "id": "right",
      "disabled": _vm.guessed2
    },
    domProps: {
      "checked": _vm._q(_vm.direction, "right")
    },
    on: {
      "change": function($event) {
        _vm.direction = "right"
      }
    }
  }), _vm._v(" "), _c('label', {
    class: _vm.classRight,
    attrs: {
      "for": "right"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("B")]), _vm._v(" "), (_vm.missed == 'right') ? _c('span', [_vm._v("\n              Since Q is less than K there are initially too many reactants and too few products present. The reaction will shift right to produce more products until equilibrium is reached.\n            ")]) : _c('span', [_vm._v("Since Q is less than K, equilibrium will shift right towards the products.")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.direction),
      expression: "direction"
    }],
    attrs: {
      "type": "radio",
      "value": "equal",
      "id": "equal",
      "disabled": _vm.guessed2
    },
    domProps: {
      "checked": _vm._q(_vm.direction, "equal")
    },
    on: {
      "change": function($event) {
        _vm.direction = "equal"
      }
    }
  }), _vm._v(" "), _c('label', {
    class: _vm.classEqual,
    attrs: {
      "for": "equal"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("C")]), _vm._v(" "), (_vm.missed == 'equal') ? _c('span', [_vm._v("Since Q is equal to K there is an equal amount of reactants and products, the reaction is at equilibrium.")]) : _c('span', [_vm._v("Since Q is equal to K, the reaction is at equilibrium.")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.guessed2),
      expression: "!guessed2"
    }],
    staticClass: "submits"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.submitTwo
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.guessed2),
      expression: "guessed2"
    }],
    staticClass: "results"
  }, [_c('div', {
    staticClass: "col-1-3 right",
    class: this.currentQ.shift === 'right' ? '' : 'fade'
  }, [_c('p', [_vm._v("Too much reactant")]), _vm._v(" "), _c('div', {
    staticClass: "bars"
  }, [_c('div', {
    staticClass: "q",
    staticStyle: {
      "height": "30%"
    }
  }, [_c('span', [_vm._v("Q")])]), _vm._v(" "), _c('div', {
    staticClass: "k",
    staticStyle: {
      "height": "60%"
    }
  }, [_c('span', [_vm._v("K")])])]), _vm._v(" "), _c('p', [_vm._v("If Q < K"), _c('sub', [_vm._v("eq")]), _vm._v(", shift to right, toward product")])]), _vm._v(" "), _c('div', {
    staticClass: "col-1-3 equal",
    class: this.currentQ.shift === 'equal' ? '' : 'fade'
  }, [_c('p', [_vm._v("Equilibrium")]), _vm._v(" "), _c('div', {
    staticClass: "bars"
  }, [_c('div', {
    staticClass: "q",
    staticStyle: {
      "height": "60%"
    }
  }, [_c('span', [_vm._v("Q")])]), _vm._v(" "), _c('div', {
    staticClass: "k",
    staticStyle: {
      "height": "60%"
    }
  }, [_c('span', [_vm._v("K")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-1-3 left",
    class: this.currentQ.shift === 'left' ? '' : 'fade'
  }, [_c('p', [_vm._v("Too much product")]), _vm._v(" "), _c('div', {
    staticClass: "bars"
  }, [_c('div', {
    staticClass: "q",
    staticStyle: {
      "height": "90%"
    }
  }, [_c('span', [_vm._v("Q")])]), _vm._v(" "), _c('div', {
    staticClass: "k",
    staticStyle: {
      "height": "60%"
    }
  }, [_c('span', [_vm._v("K")])])]), _vm._v(" "), _c('p', [_vm._v("If Q > K"), _c('sub', [_vm._v("eq")]), _vm._v(", shift to left, toward reactant")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.guessed2 && (_vm.alright || _vm.missed)),
      expression: "guessed2 && (alright||missed)"
    }],
    staticClass: "submits"
  }, [(_vm.alright) ? _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.nextQuestion
    }
  }, [_vm._v("Correct! Next Question")]) : _vm._e(), _vm._v(" "), (_vm.missed) ? _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.nextQuestion
    }
  }, [_vm._v("Next Question")]) : _vm._e()])])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.completed),
      expression: "completed"
    }],
    staticClass: "completed"
  }, [_c('div', {
    staticClass: "question"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "concentrations"
  }, [_c('span', [_vm._v("You got " + _vm._s(_vm.correct) + " out of " + _vm._s(this.questions.length) + "!")])]), _vm._v(" "), _c('div', {
    staticClass: "submits"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.resetEverything
    }
  }, [_vm._v("Restart Quiz")])])])]), _vm._v(" "), (_vm.debug) ? _c('div', {
    staticClass: "debug"
  }, [_vm._v("\n    debug:"), _c('br'), _vm._v("\n    #" + _vm._s(this.currentCount + 1) + " out of " + _vm._s(this.questions.length) + ", score: " + _vm._s(_vm.correct)), _c('br'), _vm._v("\n    Q = " + _vm._s(this.currentQ.answer) + " × 10"), _c('sup', [_vm._v(_vm._s(this.currentQ.exponent))]), _c('br'), _vm._v("\n    shift: " + _vm._s(this.currentQ.shift) + "\n  ")]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    attrs: {
      "id": "title"
    }
  }, [_vm._v("Predicting Shifts In Equilibrium: "), _c('span', [_vm._v("Q")]), _vm._v(" vs "), _c('span', [_vm._v("K")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "equation"
  }, [_c('span', [_vm._v("Quiz complete!")])])
}]}

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.startedQuiz === false),
      expression: "startedQuiz === false"
    }],
    key: "intro",
    staticClass: "intro"
  }, [_c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "intro-inner"
  }, [_c('h1', [_vm._v("Predicting Shifts in Equilibrium: Q vs K")]), _vm._v(" "), _c('p', [_vm._v("Calculate the value of the reaction quotient and compare it to the value of the equilibrium constant provided. Then predict which way the reaction will shift to reach equilibrium.")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.startedQuiz = true
      }
    }
  }, [_vm._v("Begin Quiz")])])]), _vm._v(" "), _c('quiz', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.startedQuiz === true),
      expression: "startedQuiz === true"
    }],
    key: "quizComponent",
    attrs: {
      "questions": _vm.questions
    },
    on: {
      "restartQuiz": function($event) {
        _vm.startedQuiz = false
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ })
],[4]);


// WEBPACK FOOTER //
// static/js/app.637c71cf724dcc818c37.js